export const actionTypes = {
  APP_SET_PACKAGE_DETAILS_MODAL_SHOW: "APP_SET_PACKAGE_DETAILS_MODAL_SHOW",
  APP_CHECK_SSO: "APP_CHECK_SSO",
  APP_CHECK_LOCATION: "APP_CHECK_LOCATION",
  APP_INIT_LANDING: "APP_INIT_LANDING",
  APP_INIT_DETAIL: "APP_INIT_DETAIL",
  APP_INIT_SUMMARY_RELATED: "APP_INIT_SUMMARY_RELATED",
  APP_INCREMENT_FAILED_TRY_COUNT: "APP_INCREMENT_FAILED_TRY_COUNT",
  APP_SKIP_COMING_CHECK_ORDER: "APP_SKIP_COMING_CHECK_ORDER",

  REGION_LOAD_COUNTRY_OPTIONS: "APP_LOAD_COUNTRY_OPTIONS",
  REGION_LOAD_PROVINCE_OPTIONS: "APP_LOAD_PROVINCE_OPTIONS",
  REGION_LOAD_CITY_OPTIONS: "APP_LOAD_CITY_OPTIONS",
  REGION_SET_COUNTRY_OPTIONS: "REGION_SET_COUNTRY_OPTIONS",
  REGION_RESET_OPTIONS: "REGION_RESET_OPTIONS",

  LANDING_SET_COMPANY_LANDING_INFO: "LANDING_SET_COMPANY_LANDING_INFO",
  LANDING_RESET_SELECTED_REGION: "LANDING_RESET_SELECTED_REGION",
  LANDING_CREATE_ORDER: "LANDING_CREATE_ORDER",
  LANDING_UPDATE_ORDER: "LANDING_UPDATE_ORDER",
  LANDING_CONFIRM_ORDER: "LANDING_CONFIRM_ORDER",
  LANDING_LOAD_ORDER: "LANDING_LOAD_ORDER",
  LANDING_LOAD_CHECK_ORDER_START: "LANDING_LOAD_ORDER_START",
  LANDING_LOAD_CHECK_ORDER_SUCCESS: "LANDING_LOAD_ORDER_SUCCESS",
  LANDING_LOAD_CHECK_ORDER_FAILED: "LANDING_LOAD_ORDER_FAILED",
  LANDING_NOTIFY_PASSED_FAILED_LIMIT: "LANDING_NOTIFY_PASSED_FAILED_LIMIT",
  LANDING_SET_TCAPTCHA_RESULT: "LANDING_SET_TCAPTCHA_RESULT",
  LANDING_CHOSE_PAYMENT_METHOD: "LANDING_CHOSE_PAYMENT_METHOD",

  LANDING_SET_EMAIL: "LANDING_SET_EMAIL",
  LANDING_SET_NAME_EN: "LANDING_SET_NAME_EN",
  LANDING_SET_NAME_TC: "LANDING_SET_NAME_TC",
  LANDING_SET_NAME_SC: "LANDING_SET_NAME_SC",
  LANDING_SET_TITLE: "LANDING_SET_TITLE",
  LANDING_SET_FIRST_NAME: "LANDING_SET_FIRST_NAME",
  LANDING_SET_LAST_NAME: "LANDING_SET_LAST_NAME",
  LANDING_SET_ADDRESS_1: "LANDING_SET_ADDRESS_1",
  LANDING_SET_ADDRESS_2: "LANDING_SET_ADDRESS_2",
  LANDING_SET_ADDRESS_3: "LANDING_SET_ADDRESS_3",
  LANDING_SET_ADDRESS_4: "LANDING_SET_ADDRESS_4",
  LANDING_SET_COUNTRY: "LANDING_SET_COUNTRY",
  LANDING_SET_STATE: "LANDING_SET_STATE",
  LANDING_SET_CITY: "LANDING_SET_CITY",
  LANDING_SET_COUNTRY_CODE: "LANDING_SET_COUNTRY_CODE",
  LANDING_SET_AREA_CODE: "LANDING_SET_AREA_CODE",
  LANDING_SET_NUMBER: "LANDING_SET_NUMBER",
  LANDING_SET_EXTENSION: "LANDING_SET_EXTENSION",
  LANDING_SET_NOB: "LANDING_SET_NOB",
  LANDING_SET_EMAIL_LANG: "LANDING_SET_EMAIL_LANG",
  LANDING_SET_SALES_REP_CODE: "LANDING_SET_SALES_REP_CODE",
  LANDING_SET_PROVIDE_BR: "LANDING_SET_PROVIDE_BR",
  LANDING_SET_BR_NUMBER: "LANDING_SET_BR_NUMBER",
  LANDING_SET_BR_VALID_START: "LANDING_SET_BR_VALID_START",
  LANDING_SET_BR_VALID_END: "LANDING_SET_BR_VALID_END",
  LANDING_SET_BR_FILE: "LANDING_SET_BR_FILE",

  WEB_TRACK_EVENT: "WEB_TRACKING_EVENT",
  WEB_TRACK_PAGE: "WEB_TRACK_PAGE",

  PAYMENT_INFO: "PAYMENT_INFO",
  TIMER_TIMES_UP: "TIMER_TIMES_UP",
  PACKAGE_DETAILS_SET: "PACKAGE_DETAILS_SET",
  PORCESS_AND_CONFIRM: "PORCESS_AND_CONFIRM",
  UPLOAD_FILE: "UPLOAD_FILE",
  CANCEL_UPLOAD_FILE: "CANCEL_UPLOAD_FILE",
  FILE_IS_PDF_TYPE: "FILE_IS_PDF_TYPE"
}

export function makeAction(type, payload) {
  let action = {
    type: type
  }
  if (payload) action.payload = payload
  return action
}

export function makePromiseAction(type, resolve, reject, payload) {
  let action = {
    type: type,
    resolve: resolve,
    reject: reject
  }
  if (payload) action.payload = payload
  return action
}

export const regionActions = {
  resetProvinceOptions: () =>
    makeAction(actionTypes.REGION_RESET_OPTIONS, {
      options: { assoiatedProvinceOptions: [], assoiatedCityOptions: [] },
      select: { state: {}, city: {} }
    }),
  resetCityOptions: () =>
    makeAction(actionTypes.REGION_RESET_OPTIONS, {
      options: { assoiatedCityOptions: [] },
      select: { city: {} }
    })
}
